{
  "es": {
    "models": {
      "image": {
        "background": "¿Usar como fondo?",
        "enabled": "¿Habilitado?",
        "global": "¿Global?",
        "delete": "Eliminar",
        "start": "Iniciar",
        "cancel": "Cancelar",
        "processing": "Procesando...",
        "error": "Error",
        "name": "Nombre",
        "size": "Tamaño de archivo",
        "dropzone": "Soltar imágenes aquí"
      }
    }
  }
}
